module.exports = __webpack_public_path__ + "img/floor_f17_02.39b955a3.png";